import { useState } from "react";
import { api, formatApiError } from "@/lib/api";

export default function Maintenance() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const unlock = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/maintenance/unlock", { password });
      localStorage.setItem("ton_maint", data.token);
      window.location.reload();
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-forest-deep text-bone flex flex-col items-center justify-center px-6">
      <img
        src="/logo-white.webp"
        onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = "/logo.webp"; }}
        className="h-40 w-40 rounded-full object-cover mb-10"
        alt="Tonpoesie"
      />
      <h1 className="font-serif text-4xl sm:text-5xl text-center">Website in Arbeit</h1>
      <p className="mt-4 max-w-md text-center text-bone/70">
        Wir werkeln gerade an der Seite – schau bald wieder vorbei.
      </p>
      <form onSubmit={unlock} className="mt-10 w-full max-w-xs space-y-3">
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Passwort"
          data-testid="maintenance-password"
          className="w-full rounded-md border border-bone/20 bg-white/10 px-4 py-2.5 text-bone placeholder:text-bone/50 focus:outline-none focus:ring-2 focus:ring-sage"
        />
        {error && <p className="text-sm text-red-300">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          data-testid="maintenance-unlock"
          className="w-full rounded-full bg-white text-forest-deep font-medium py-2.5 hover:bg-bone transition-colors disabled:opacity-60"
        >
          {loading ? "Prüfe…" : "Freischalten"}
        </button>
      </form>
    </div>
  );
}
